import React from 'react';
export function Pain() {
  const pains = [{
    title: 'Llegás al turno y improvisás',
    desc: 'Sin saber qué protocolo seguir, qué documentar o cómo presentarle el tratamiento al paciente de forma clara.'
  }, {
    title: 'Sin consentimientos firmados',
    desc: 'Sabés que cualquier procedimiento sin respaldo legal es un riesgo real — y seguís sin tener nada en orden.'
  }, {
    title: 'Tu asistente no puede trabajar solo',
    desc: 'Sin protocolos escritos, todo depende de que vos estés presente. Si faltás, el consultorio para.'
  }, {
    title: 'Los pacientes no vuelven al control',
    desc: 'No porque estén disconformes — porque nadie los llamó ni les mandó nada después del tratamiento.'
  }, {
    title: 'No sabés a dónde va la plata',
    desc: 'Trabajás todo el mes y a fin de mes el número no cierra. Sin sistema de cobro ni control de ingresos.'
  }, {
    title: 'Fichas clínicas incompletas o en papel',
    desc: 'La información de tus pacientes dispersa, sin un sistema claro que cualquiera pueda usar.'
  }, {
    title: 'No podés tomarte vacaciones',
    desc: 'El consultorio depende 100% de vos. Sin sistema, no hay forma de delegar ni de desconectarte.'
  }, {
    title: 'Fin de mes sin saber cuánto ganaste',
    desc: 'Sin registro de ingresos, egresos ni indicadores, trabajás a ciegas y tomás decisiones sin datos.'
  }];
  return <section className="bg-navy px-5 py-10 md:py-[70px] text-center" data-id="element-174">
      <div className="mx-auto max-w-[960px]" data-id="element-175">
        <p className="mb-3 font-montserrat text-[11px] font-extrabold uppercase tracking-[3px] text-brandRed" data-id="element-176">
          ¿Te pasa esto?
        </p>
        <h2 className="mb-2 font-bebas text-[clamp(32px,5vw,56px)] tracking-[1px] text-white" data-id="element-177">
          Si atendés en Argentina,
          <br data-id="element-178" />
          <span className="text-brandRed" data-id="element-179">esto te suena familiar</span>
        </h2>
        <p className="mx-auto mb-6 md:mb-[44px] max-w-[560px] text-[16px] text-white/65" data-id="element-180">
          Si trabajás en tu consultorio, estas situaciones aparecen más seguido
          de lo que quisieras.
        </p>

        <div className="mb-6 md:mb-[44px] grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-181">
          {pains.map((pain, i) => <div key={i} className="rounded-[10px] border border-white/10 bg-white/5 p-[22px_20px] text-left" data-id="element-182">
              <p className="mb-2 font-montserrat text-[14px] font-bold text-white" data-id="element-183">
                {pain.title}
              </p>
              <p className="text-[13px] leading-relaxed text-white/55" data-id="element-184">
                {pain.desc}
              </p>
            </div>)}
        </div>

        <p className="mb-8 font-montserrat text-[clamp(16px,3vw,22px)] font-extrabold text-gold" data-id="element-185">
          ¿Cuántos meses más vas a manejar el consultorio sin un sistema?
        </p>
        <a href="#oferta" className="inline-block rounded-md bg-btn-red px-[44px] py-[18px] font-montserrat text-[clamp(14px,2.5vw,18px)] font-black uppercase tracking-[0.5px] text-white shadow-[0_8px_32px_rgba(230,57,70,0.45)] transition-all hover:-translate-y-0.5 hover:shadow-[0_12px_40px_rgba(230,57,70,0.55)]" data-id="element-186">
          QUIERO ORDENAR MI CONSULTORIO AHORA
        </a>
      </div>
    </section>;
}